import {
    getActivityCount,
    getHighlightCount,
} from '../../selectors/ninchat'
import React from 'react'
import SidebarView from './SidebarView'
import {navigation} from '../../navigation'
import {useAppSelector} from '../../hooks'

const Sidebar: React.FC = (): React.ReactElement => {
    const changeRoute = React.useCallback((type: string): void => {
        switch (type) {
            case 'Settings':
                navigation.push(type)
                break
            case 'Home':
            default:
                navigation.push('Home')
        }
    }, [])

    const realm_id = useAppSelector(({ui}) => ui.realm_id)
    const activityCount = useAppSelector(({
        ninchat, ui,
    }) => getActivityCount(ninchat, ui.queue_pickup_delays))
    const highlightCount = useAppSelector(({
        ninchat, ui,
    }) => getHighlightCount(ninchat, ui.queue_pickup_delays))
    const sidebar_classic_audience_grouping = useAppSelector(({ninchat}) => ninchat.user_settings.sidebar_classic_audience_grouping ?? false)

    return (
        <SidebarView
            activityCount={activityCount}
            changeRoute={changeRoute}
            hasActivity={activityCount > 0}
            hasHighlight={highlightCount > 0}
            highlightCount={highlightCount}
            realm_id={realm_id}
            sidebar_classic_audience_grouping={sidebar_classic_audience_grouping}
        />
    )
}

export default Sidebar
